import Container from "../common/Container";

const Footer = () => {
  const getCurrentYear = () => {
    const currentDate = new Date();
    return currentDate.getFullYear();
  };

  return (
    <footer>
      <Container>
        <span className="footer-copy">
          © {getCurrentYear()} Xhonatan Hajdari
        </span>
      </Container>
    </footer>
  );
};

export default Footer;
